import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CalendarDateFormatter, DateAdapter, DateFormatterParams } from 'angular-calendar';
import moment from 'moment';
import { LocalizationState } from '@nimbus-library/features/localization/store/localization.state';

@Injectable()
export class NimbusCalendarDateFormatter extends CalendarDateFormatter {
  public constructor(
    private readonly store: Store,
    dateAdapter: DateAdapter,
  ) {
    super(dateAdapter);
  }

  public dayViewHour({ date, locale }: DateFormatterParams): string {
    const selectedLocale = this.store.selectSnapshot(LocalizationState.selectedDateFormat);
    return moment(date).locale(selectedLocale).format('LT');
  }

  public weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
    const selectedLocale = this.store.selectSnapshot(LocalizationState.selectedDateFormat);
    return moment(date).locale(selectedLocale).format('ddd, L');
  }

  public weekViewHour({ date, locale }: DateFormatterParams): string {
    return this.dayViewHour({ date, locale });
  }

  public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
    const selectedLocale = this.store.selectSnapshot(LocalizationState.selectedDateFormat);
    return moment(date).locale(selectedLocale).format('dddd');
  }
}
